import { Injectable } from '@angular/core';

import { Actions } from '@ngrx/effects';
import { map } from 'rxjs/operators';

import { createEffectFactory } from '@recruitee/ngrx';

import { RemoteTemplateHttpClient } from './remote-template-http.client';
import { RemoteTemplateActions } from './remote-template.store';

@Injectable({ providedIn: 'root' })
export class RemoteTemplateEffects {
  public effect = createEffectFactory(RemoteTemplateActions, this.actions$);

  public fetchRemoteTemplates$ = this.effect(RemoteTemplateActions.fetchCollection, ({ payload }) =>
    this.remoteTemplateHttpClient
      .fetch(payload!.scope)
      .pipe(map(remoteTemplates => ({ data: remoteTemplates, scope: payload!.scope }))),
  );

  constructor(
    private remoteTemplateHttpClient: RemoteTemplateHttpClient,
    private actions$: Actions,
  ) {}
}
